"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceData = exports.default = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../providers/CetComponentsProvider");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useDeviceData = function useDeviceData(contextValues) {
  var _contextValues$mobile, _contextValues$isUpda, _contextValues$rootFo;
  var isFromProvider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = document.querySelector('html');
  var isRunning = (0, _react.useRef)(false);
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    mobileBreakpoint = _useContext.mobileBreakpoint,
    isUpdateFontSizeOnResizeEnabled = _useContext.isUpdateFontSizeOnResizeEnabled,
    rootFontSize = _useContext.rootFontSize;
  //on first load this hooks is being called before context is initialized
  mobileBreakpoint = (_contextValues$mobile = contextValues === null || contextValues === void 0 ? void 0 : contextValues.mobileBreakpoint) !== null && _contextValues$mobile !== void 0 ? _contextValues$mobile : mobileBreakpoint;
  isUpdateFontSizeOnResizeEnabled = (_contextValues$isUpda = contextValues === null || contextValues === void 0 ? void 0 : contextValues.isUpdateFontSizeOnResizeEnabled) !== null && _contextValues$isUpda !== void 0 ? _contextValues$isUpda : isUpdateFontSizeOnResizeEnabled;
  rootFontSize = (_contextValues$rootFo = contextValues === null || contextValues === void 0 ? void 0 : contextValues.rootFontSize) !== null && _contextValues$rootFo !== void 0 ? _contextValues$rootFo : rootFontSize;
  var userAgent = (0, _react.useMemo)(function () {
    return navigator.userAgent || navigator.vendor || window.opera;
  }, []);
  var getFontSize = (0, _react.useCallback)(function (width, mobileBreakpoint) {
    var _rootFontSize;
    var rootFS = (_rootFontSize = rootFontSize) !== null && _rootFontSize !== void 0 ? _rootFontSize : 10;
    switch (true) {
      case width > 1600:
        return rootFS;
      case width > 1366 && width <= 1600:
        return rootFS * 0.9;
      case width > mobileBreakpoint && width <= 1366:
        return rootFS * 0.8;
      case width > 375 && width <= mobileBreakpoint:
        return rootFS;
      case width <= 375:
        return width > 375 ? rootFS : rootFS * width / 375;
    }
  }, [rootFontSize]);
  var isMobileDevice = function isMobileDevice() {
    var check = false;
    (function (a) {
      if (
      //eslint-disable-next-line
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
      //eslint-disable-next-line
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };
  var getDeviceData = (0, _react.useCallback)(function () {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var isLandscape = width > height; // && typeof window.orientation !== 'undefined';
    var isPortrait = width <= height; // && typeof window.orientation !== 'undefined';
    var isAndroid = !!userAgent.match(/Android/i);
    var isIOS = !!userAgent.match(/iPhone|iPad|iPod/i);
    var isMobile = isMobileDevice();
    var isMobileView = isMobile || width <= Number(mobileBreakpoint);
    var isTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var htmlFontSize = isUpdateFontSizeOnResizeEnabled ? getFontSize(width, Number(mobileBreakpoint)) + 'px' : '10px';
    if (html && isUpdateFontSizeOnResizeEnabled && isFromProvider) {
      html.style.fontSize = htmlFontSize;
    }
    return {
      isMobile: isMobile,
      isAndroid: isAndroid,
      isIOS: isIOS,
      isLandscape: isLandscape,
      isPortrait: isPortrait,
      isDesktop: !isMobile,
      isMobileView: isMobileView,
      isTouchScreen: isTouchScreen,
      viewWidth: width,
      viewHeight: height,
      isDeviceDataReady: true,
      htmlFontSize: htmlFontSize
    };
  }, [getFontSize, html, isFromProvider, isUpdateFontSizeOnResizeEnabled, mobileBreakpoint, userAgent]);
  var updateDeviceData = (0, _react.useCallback)(function () {
    if (isRunning.current) {
      return;
    }
    isRunning.current = true;
    requestAnimationFrame(function () {
      setTimeout(function () {
        var updated = getDeviceData();
        setDeviceData(updated);
        isRunning.current = false;
      }, 100);
    });
  }, [getDeviceData]);
  var _useState = (0, _react.useState)(function () {
      return getDeviceData();
    }),
    _useState2 = _slicedToArray(_useState, 2),
    deviceData = _useState2[0],
    setDeviceData = _useState2[1];
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', updateDeviceData);
    return function () {
      window.removeEventListener('resize', updateDeviceData);
    };
  }, [updateDeviceData]);
  return deviceData;
};
exports.useDeviceData = useDeviceData;
var _default = useDeviceData;
exports.default = _default;